<template>
  <div class="MyRank fs14">
    <logo :logo="logo.aiyouth" class="logo"></logo>
    <div class="share" @click="nav">分享</div>
    <div class="tips" v-if="!user.enrolled">
      <my_image :src="img.img" :width="img.width"></my_image>
      <div class="red">您当前未报名</div>
      <div>了解更多比赛信息和查看比赛报名入口</div>
      <div>请使用电脑登录<a href="http://aiyouth.org.cn">aiyouth.org.cn</a></div>
    </div>
    <div class="tb">
      <div v-for="(v, k) in info" class="column">
        <div class="key">{{k}}</div>
        <div class="value">{{v}}</div>
      </div>
    </div>

    <div class="process">
      <div class="box" v-for="(e, index) in events">
        <process_line v-if="index>1"></process_line>
        <time_event v-if="index != 0" :event="e.event" :time="e.time" :color="color[index]"></time_event>
      </div>
    </div>

    <div class="introduction fs12">
      <div class="intro-title fs14">排名积分说明</div>
      <p v-for="para in instructions">
        {{para}}
      </p>
    </div>

    <div class="logos">
      
      <logo :logo="logo.ccid" :inputStyle="width" class="logo"></logo>
      <logo :logo="logo.coco" :inputStyle="width" class="logo"></logo>
    </div>
    <m_bottom_bar></m_bottom_bar>
  </div>
</template>

<script>
 import MyImage from '@/components/Image.vue'
 import WarnPNG from '@/assets/image/rank/warn.png'
 import TimeEvent from '@/components/rank/TimeEvent.vue'
 import Processline from '@/components/rank/Processline.vue'
 import Logo from '@/components/Logo.vue'
 import MBottomBar from '@/components/mobile/MBottomBar.vue'

 export default {
   name: 'MyRank',
   props: ['info'],
   data() {
     return {
       uuid: '',
       instructions: [
         '1. 初赛截止时间为 11月11日23:59，截止时积分为正的选手即可晋级进入复赛。',
         '2. 全国排名按照组别排名。你可以查到自己的积分和全国排名。',
         '3. 排行榜每晚 20点 从竞技场获取最新积分数据更新排名。',
         '4. 初赛竞技场中，建议选手分别尝试红方和蓝方，取红方和蓝方最高分作为排名积分。',
         '5. 排名是根据选手代码的竞赛结果（在竞技场"我的对手"查看），系统自动计算积分。因此优秀的代码和策略会排在前面。',
         '6. 排名和加入竞技场的时间没有关系，因此后加入的选手也有机会排在前面。而先加入的选手因为排名更新而排在后面。',
         '7. 初赛竞技场的代码可以随时调整和更新，排名也会随着更新和变化。建议关注排名，调整自己的代码。 ',
         '8. 建议选手尝试挑战排名靠前的选手，战胜排名靠前的选手会得到更多的分数。',
       ]
     }
   },
   mounted() {
     this.$http.post('/api/rank/share')
         .then(res=>{
           console.log(res);
           this.uuid = res.data
     })
   },
   methods:{
     nav(){
       let date = new Date()
       let string = (date.getMonth()+1)+'-'+date.getDate()
       this.$router.push({name: 'Share', params: {uuid: this.uuid, title: this.user.name+'的AI世青赛战绩|'+string}});
       /* window.location.href = '/share.html?uuid='+ this.uuid +'&title='+(this.user.name+'的AI世青赛战绩|'+string);*/
     }
   },
   computed: {
     width() {
       return {'width': '40vw'};
     },
     logo() {
       return {
         aiyouth:this.$store.state.logo.mainBlack,
         ccid: this.$store.state.logo.ccidRed,
         coco: this.$store.state.logo.coco
       }
     },
     img() {
       return {
         img: WarnPNG,
         width: '25vw'
       }
     },
     events() {
       return this.$store.state.frontpage.process
     },
     color() {
       return [
         '#7ade61',
         // 'linear-gradient(to right, #4ca2f9, #405bee)',
         /* '#2f4fff',*/
         '#4ca2f9',
         '#405bee',
         '#4ca2f9'

         // 'linear-gradient(to right, #4ca2f9, #405bee)',
       ]
     },
     user() {
       return this.$store.state.auth.user
     }
   },
   components: {
     my_image: MyImage,
     time_event: TimeEvent,
     process_line: Processline,
     logo: Logo,
     m_bottom_bar: MBottomBar

   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .logo{
   margin-bottom: 6vw;
 }

 .MyRank{
   margin-left: auto;
   margin-right: auto;
   margin-top: 10vw;
   margin-bottom: 20vw;
   color: white;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;

 }

 .tb{
   background: linear-gradient(to right, #4ca2f9, #405bee);
   box-sizing: border-box;
   flex-direction: column;
   width: 80vw;
   /* height: 20vw; */
   display: flex;
   font-size: 12px;
   border-radius: 2vw;
 }

 .column{
   flex-grow: 1;
   height: 100%;
   display: flex;
   align-items: center;
   justify-content: space-around;
 }

 .column > div{
   height: 10vw;
   display: flex;
   justify-content: center;
   align-items: center;
   border-right: 0.5px solid rgba(255, 255, 255, 0.6);
   border-bottom: 0.5px solid rgba(255, 255, 255, 0.6);
 }
 .column .key{
   flex-basis: 25vw;
 }
 .column .value{
   flex-grow: 1;
 }

 .process{
   margin-top: 4vw;
 }

 .tips{
   color: grey;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
   height: 45vw;
   margin-bottom: 5vw;
   padding: 0 5vw;
 }

 .red{
   color: red;
 }

 .introduction{
   color: black;
   margin: 5vw;
   padding: 0 3vw;
   border: 0.3vw solid #4ca2f9;
   border-radius: 2vw;
 }
 .intro-title{
   text-align: center;
   color: #405bee;
   margin-top: 3vw;
 }
 .logos{
   width: 100vw;
   display: flex;
   align-items: center;
   justify-content: space-around;
 }
 .ccid{
   background-color: #4ca2f9;
 }
 
 .share{
   position: absolute;
   top: 5vh;
   right: 5vw;
   width: 3em;
   height: 3em;
   display: flex;
   justify-content: center;
   align-items:center;
   border-radius: 50%;
   background-color: #5DAC81;

 }
</style>
